import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Person from 'app/common/classes/person'
import { IdentifierType } from 'app/common/constants/identifiers'
import * as identifierTypes from 'app/common/constants/identifiers/types'
import { useDealerPhone } from 'app/dataProviders/dealer/hooks'

export function useError(student: Person) {
  const { t } = useTranslation('identifiers-next')
  const phone = useDealerPhone()

  const [lastError, setLastError] = useState({ value: '' })

  const createErrorText = useCallback(
    (
      identifierType: IdentifierType | null,
      identifierCode: string,
      flag?: 'shotVersion',
      errorStatus?: 'ALREADY_APPENDED' | 'PREPAID_NOT_FOUND' | 'UNKNOWN',
    ) => {
      const errorCode = errorStatus || lastError.value

      if (errorCode === 'ALREADY_APPENDED') {
        return t(
          'identifiers_append_error_already_exist', // Идентификатор уже добавлен Иванову Ивану
          { name: student.komuChemu.toString(Person.FullNameType.LastFirst) },
        )
      }

      if (errorCode === 'PREPAID_NOT_FOUND' && flag !== 'shotVersion') {
        return identifierType === identifierTypes.IDENTIFIER_TINKOFF
          ? t('identifiers_append_status_error_tinkoff', { phone })
          : t('identifiers_append_status_error', { code: identifierCode })
      }

      if (errorCode) {
        return t('identifiers_append_error', 'Не удалось добавить идентификатор')
      }

      return ''
    },
    [lastError, student, t, phone],
  )

  const setError = useCallback(
    (
      identifierType: IdentifierType | null,
      identifierCode: string,
      errorStatus: 'ALREADY_APPENDED' | 'PREPAID_NOT_FOUND' | 'UNKNOWN',
      flag?: 'shotVersion',
    ) => {
      setLastError({ value: errorStatus })
      return createErrorText(identifierType, identifierCode, flag, errorStatus)
    },
    [createErrorText],
  )

  const resetError = useCallback(() => {
    setLastError({ value: '' })
  }, [])

  return {
    createErrorText,
    setError,
    resetError,
  }
}
